
import { defineAsyncComponent, defineComponent, PropType } from 'vue';

import Message from '@/models/MessageModel';
import BotAvatar from '@/components/App/BotAvatar.vue';
import MessageTail from './MessageTail.vue';
import { autoLinkHtml } from '@/helpers/AutoLinkHtml';

export default defineComponent({
	name: 'message-item',

	components: {
		BotAvatar,
		MessageTail,
		mediaImage: defineAsyncComponent(() => import('@/components/MessageImage.vue')),
		mediaAudio: defineAsyncComponent(() => import('@/components/MessageAudio.vue')),
		mediaRemote: defineAsyncComponent(() => import('@/components/MessageVideo.vue')),
		mediaReport: defineAsyncComponent(() => import('@/components/MessageReport.vue')),
		mediaFile: defineAsyncComponent(() => import('@/components/MessageFile.vue'))
	},

	props: {
		isShowMessageTail: {
			type: Boolean
		},

		message: {
			type: Object as PropType<Message>
		},

		avatar: {
			type: String
		}
	},

	computed: {
		parsedMessage(): string {
			return autoLinkHtml(this.message?.text || '');
		},
		isInsideMedia(): boolean {
			return !!(this.message && (this.message.audio || this.message.file));
		},
		isMediaVisible(): boolean {
			return !!(
				this.message &&
				(this.message.image ||
					this.message.remote ||
					this.message.report_url ||
					this.message.video)
			);
		},
		isMediaComponent(): {
			component: string;
			src: string;
			hosting?: string;
			autoplay?: boolean;
		} {
			const data = {
				component: '',
				src: '',
				hosting: '',
				autoplay: false
			};
			if (!this.message) return data;
			if (this.message.image) {
				data.component = 'mediaImage';
				data.src = this.message.image;
			}
			if (this.message.audio) {
				data.component = 'mediaAudio';
				data.src = this.message.audio;
			}
			if (this.message.remote) {
				data.component = 'mediaRemote';
				data.src = this.message.remote;
			}
			if (this.message.video) {
				data.component = 'mediaRemote';
				data.src = this.message.video;
				data.hosting = this.message.video_hosting || '';
				data.autoplay = this.message.video_autoplay || false;
			}
			if (this.message.report_url) {
				data.component = 'mediaReport';
				data.src = this.message.report_url;
			}
			if (this.message.file) {
				data.component = 'mediaFile';
				data.src = this.message.file;
			}
			return data;
		},
		isPhoneSize(): boolean {
			return this.$q.screen.name === 'xs';
		},

		messageTextIsNotEmpty(): boolean {
			return this.message?.text !== '' && this.message?.text !== '\n';
		}
	}
});
